import { Inventory } from './inventory.model';
import * as InventoryAction from './inventory.action';

export interface InventoryState {
    readonly inventory: Inventory;
    loading: boolean;
}

export function inventoryReducer(state: Inventory, action: InventoryAction.InventoryActions) {
    switch (action.type) {

        case InventoryAction.GET_INVENTORY:
            return action.payload;

        default: return state;
    }
}
